import React, { useRef, useState } from "react";
import { Button, Form, Mentions, Modal, Space, notification } from "antd";
import {
	FiAlertCircle,
	FiArrowLeft,
	FiArrowRight,
	FiPlusCircle,
} from "react-icons/fi";
import serviceHome from "../../services/home";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import { removeStorageWhenLogout } from "../../config/helper";

const ModalPromptUpdate = ({ openModal, onClose = () => {} }) => {
	const navigate = useNavigate();

	const [thePromptContext, setThePromptContext] = useState(null);

	const handleUpdatePromptText = async () => {
		const payload = {
			data: {
				newContext: thePromptContext,
			},
		};
		const response = await serviceHome.updatePromptContext(payload);

		if (response.httpStatus === 401) {
			notification.error({ message: "Unauthorize!" });
			removeStorageWhenLogout();
			setTimeout(() => {
				navigate("/signin");
			}, config.timeout);
		}
		if (response.httpStatus === 200) {
			notification.success({ message: "Prompt text has been updated." });
			setTimeout(() => {
				onClose({
					updatePromptShow: false,
					adminPromptShow: true,
				});
			}, config.timeout);
		}
	};

	return (
		<Modal
			footer={null}
			className="profile-modal"
			open={openModal}
			onCancel={() =>
				onClose({
					adminPromptShow: true,
					updatePromptShow: false,
				})
			}
			destroyOnClose
		>
			<div className="top-section">
				<div className="user-profile">
					<Button
						className="user-profile-icon"
						icon={<FiArrowLeft size={24} />}
						onClick={() =>
							onClose({
								adminPromptShow: true,
								updatePromptShow: false,
							})
						}
					/>
					Update prompt context
				</div>
				<div
					className="user-profile-wrapper"
					style={{ marginBottom: 24 }}
				>
					<span>Enter new prompt context</span>
				</div>
				<Form>
					<Form.Item>
						<Mentions
							autoSize
							className="prompt-mention-field"
							placeholder="You can use { to ref user here"
							prefix="{"
							options={[
								{
									value: "characterAiName}",
									label: "characterAiName",
								},
								{
									value: "characterAiInterests}",
									label: "characterAiInterests",
								},
								{
									value: "characterAiPersonality}",
									label: "characterAiPersonality",
								},
								{
									value: "userName}",
									label: "userName",
								},
								{
									value: "dob}",
									label: "dob",
								},
								{
									value: "gender}",
									label: "gender",
								},
								{
									value: "today}",
									label: "today",
								},
							]}
							value={thePromptContext}
							onChange={(value) => setThePromptContext(value)}
						/>
					</Form.Item>
					<Form.Item>
						<Space className="ant-btn-tags" wrap>
							{[
								"characterAiName",
								"characterAiInterests",
								"characterAiPersonality",
								"dob",
								"userName",
								"gender",
								"today",
							].map((item) => (
								<Button
									key={item}
									type="primary"
									onClick={() =>
										setThePromptContext(
											`${thePromptContext} {${item}}`
										)
									}
								>
									<FiPlusCircle />
									{item}
								</Button>
							))}
						</Space>
					</Form.Item>
					<Form.Item>
						<Button
							type="primary"
							onClick={handleUpdatePromptText}
							style={{
								background: "#1E2DD3",
								borderColor: "#1E2DD3",
							}}
						>
							Update
							<FiArrowRight />
						</Button>
					</Form.Item>
				</Form>
				<div className="info-warning">
					<FiAlertCircle size={24} />
					After updating a new prompt, please clear your chat history
					with all characters to avoid any confusion.
				</div>
			</div>
		</Modal>
	);
};

export default ModalPromptUpdate;
